import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { useApi } from "../../services/api";
import { ActiveUsersChart } from "./ActiveUsersChart";
import { ModuleUsageChart } from "./ModuleUsageChart";
import { NewContractsChart } from "./NewContractsChart";

const TILES = [
  { key: "daily_active_users", label: "Daily Active Users" },
  { key: "weekly_active_users", label: "Weekly Active Users" },
  { key: "monthly_active_users", label: "Monthly Active Users" },
  { key: "total_users", label: "Total Users" },
];

export const Analytics = () => {
  const { apiFetch } = useApi();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    async function loadData() {
      apiFetch("/api/analytics/summary")
        .then((response) => response.json())
        .then((data) => {
          setSummary(data);
        })
        .catch(() => {
          alert("Error occured while loading analytics summary");
        });
    }
    loadData();
  }, [apiFetch]);

  return (
    <>
      <div className="row mt-5 justify-content-end mb-2">
        <div className="col-md-11">
          <div className="row">
            {TILES.map((tile) => (
              <div className="col-md-3 mb-3" key={tile.key}>
                <Card className="shadow" data-testid={"tile-" + tile.key}>
                  <CardBody>
                    <CardTitle style={{ textAlign: "left", fontSize: "14px", color: "#575757" }}>
                      {tile.label}
                    </CardTitle>
                    <h3 style={{ textAlign: "left", color: "#4A42A0" }}>
                      {summary ? summary[tile.key] : "-"}
                    </h3>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-md-7 mb-3">
              <ActiveUsersChart />
            </div>
            <div className="col-md-5 mb-3">
              <ModuleUsageChart />
            </div>
          </div>
          <div className="row">
            <div className="col-md-7 mb-3">
              <NewContractsChart />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
